import { gql, useMutation } from '@apollo/client'
import { useNavigate } from '@reach/router'

import { checklistsClient } from '../../../../utils/apollo/api'
import { cleanRequest } from './cleanRequest'
import { useChecklistForm } from '../_form/ChecklistFormHandler'
import { useChecklist } from '../_load/ChecklistLoader'

const MUTATION = gql`
  mutation UpsertChecklist($input: ChecklistInput) {
    upsertChecklist(input: $input) {
      id
    }
  }
`

export const useSaveChecklist = () => {
  const form = useChecklistForm()
  const checklist = useChecklist()
  const navigate = useNavigate()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Checklists'], client: checklistsClient })

  const handleRequest = () => {
    const input = cleanRequest(form, checklist)

    return request({ variables: { input } })
      .then(resp => {
        if (!resp.errors) {
          navigate(`/checklists`)
        }
      })
      .catch(() => {
        // Mutation errors (e.g. the backend's allowBulkExecution + conditional logic
        // validation) are already surfaced via the `error` state from useMutation,
        // which feeds the Steps error banner (see EditChecklistForm). Swallow the
        // rejection here just to avoid an unhandled promise rejection.
      })
  }

  return [handleRequest, state]
}
